import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { CorporationAlert } from '../../interfaces/corporation-alerts/corporation-alert';
import { CorporationAlertForCreation } from '../../interfaces/corporation-alerts/corporation-alert-for-creation';
import { CorporationAlertForUpdate } from '../../interfaces/corporation-alerts/corporation-alert-for-update';
import { CorporationAlertForBatchUpdate } from '../../interfaces/corporation-alerts/corporation-alert-for-batch-update';

@Injectable({
  providedIn: 'root',
})
export class CorporationAlertsRepositoryServiceService extends PaginatedRepository<CorporationAlert> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);

    this._baseLinkTemplate = `${config.rootUrl}/Corporations/[0]/CorporationAlerts`;
    this._baseLink = this._baseLinkTemplate;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }

  private getURL = (corporationID: string, alertID?: string) => {
    this.populateBaseLink([corporationID]);

    if (alertID) {
      return `${this._baseLink}/${alertID}`;
    }
    return this._baseLink;
  }

  public getCorporationAlerts = (corporationID: string, httpParams?: HttpParams) => {
    return this.http.get<CorporationAlert[]>(this.getURL(corporationID), { params: httpParams });
  }

  public getCorporationAlert = (corporationID: string, alertID: string) => {
    return this.http.get<CorporationAlert>(this.getURL(corporationID, alertID));
  }

  public createCorporationAlert = (corporationID: string, newAlert: CorporationAlertForCreation) => {
    return this.http.post<CorporationAlert>(
      this.getURL(corporationID),
      newAlert,
      this.generateHeaders());
  }

  public updateCorporationAlert = (corporationID: string, alertID: string, updatedAlert: CorporationAlertForUpdate) => {
    return this.http.put<CorporationAlert>(
      this.getURL(corporationID, alertID),
      updatedAlert,
      this.generateHeaders());
  }

  // Saves several alert types in one call and returns all of the corporation's alerts
  public batchUpdateCorporationAlerts = (corporationID: string, corporationAlerts: CorporationAlertForBatchUpdate[]) => {
    return this.http.put<CorporationAlert[]>(
      `${this.getURL(corporationID)}/Batch`,
      corporationAlerts,
      this.generateHeaders());
  }

  public deleteCorporationAlert = (corporationID: string, alertID: string) => {
    return this.http.delete(this.getURL(corporationID, alertID));
  }
}